
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $6f019d1f45ba2738$export$2e2bcd8739ae039(targetElements, defaultProps) {
    if (!targetElements.length) return;
    ScrollReveal({
        reset: false
    });
    targetElements.forEach(({ element: element, animation: animation })=>{
        ScrollReveal().reveal(element, Object.assign({}, defaultProps, animation));
    });
}


var $b5f6d4efc654cf78$exports = {};
'use strict';
var $b5f6d4efc654cf78$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.8.0
 */ var $b5f6d4efc654cf78$var$VanillaTilt = function() {
    function VanillaTilt(element) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $b5f6d4efc654cf78$var$classCallCheck(this, VanillaTilt);
        if (!(element instanceof Node)) throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
        this.width = null;
        this.height = null;
        this.clientWidth = null;
        this.clientHeight = null;
        this.left = null;
        this.top = null;
        // for Gyroscope sampling
        this.gammazero = null;
        this.betazero = null;
        this.lastgammazero = null;
        this.lastbetazero = null;
        this.transitionTimeout = null;
        this.updateCall = null;
        this.event = null;
        this.updateBind = this.update.bind(this);
        this.resetBind = this.reset.bind(this);
        this.element = element;
        this.settings = this.extendSettings(settings);
        this.reverse = this.settings.reverse ? -1 : 1;
        this.resetToStart = VanillaTilt.isSettingTrue(this.settings["reset-to-start"]);
        this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
        this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
        this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
        this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
        this.gyroscopeSamples = this.settings.gyroscopeSamples;
        this.elementListener = this.getElementListener();
        if (this.glare) this.prepareGlare();
        if (this.fullPageListening) this.updateClientSize();
        this.addEventListeners();
        this.reset();
        if (this.resetToStart === false) {
            this.settings.startX = 0;
            this.settings.startY = 0;
        }
    }
    VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
        return setting === "" || setting === true || setting === 1;
    };
    /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */ VanillaTilt.prototype.getElementListener = function getElementListener() {
        if (this.fullPageListening) return window.document;
        if (typeof this.settings["mouse-event-element"] === "string") {
            var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);
            if (mouseEventElement) return mouseEventElement;
        }
        if (this.settings["mouse-event-element"] instanceof Node) return this.settings["mouse-event-element"];
        return this.element;
    };
    /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */ VanillaTilt.prototype.addEventListeners = function addEventListeners() {
        this.onMouseEnterBind = this.onMouseEnter.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseLeaveBind = this.onMouseLeave.bind(this);
        this.onWindowResizeBind = this.onWindowResize.bind(this);
        this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);
        this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);
        if (this.glare || this.fullPageListening) window.addEventListener("resize", this.onWindowResizeBind);
        if (this.gyroscope) window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    };
    /**
   * Method remove event listeners from current this.elementListener
   */ VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
        this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);
        if (this.gyroscope) window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
        if (this.glare || this.fullPageListening) window.removeEventListener("resize", this.onWindowResizeBind);
    };
    VanillaTilt.prototype.destroy = function destroy() {
        clearTimeout(this.transitionTimeout);
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.reset();
        this.removeEventListeners();
        this.element.vanillaTilt = null;
        delete this.element.vanillaTilt;
        this.element = null;
    };
    VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
        if (event.gamma === null || event.beta === null) return;
        this.updateElementPosition();
        if (this.gyroscopeSamples > 0) {
            this.lastgammazero = this.gammazero;
            this.lastbetazero = this.betazero;
            if (this.gammazero === null) {
                this.gammazero = event.gamma;
                this.betazero = event.beta;
            } else {
                this.gammazero = (event.gamma + this.lastgammazero) / 2;
                this.betazero = (event.beta + this.lastbetazero) / 2;
            }
            this.gyroscopeSamples -= 1;
        }
        var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
        var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;
        var degreesPerPixelX = totalAngleX / this.width;
        var degreesPerPixelY = totalAngleY / this.height;
        var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
        var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);
        var posX = angleX / degreesPerPixelX;
        var posY = angleY / degreesPerPixelY;
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = {
            clientX: posX + this.left,
            clientY: posY + this.top
        };
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
        this.updateElementPosition();
        this.element.style.willChange = "transform";
        this.setTransition();
    };
    VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = event;
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
        this.setTransition();
        if (this.settings.reset) requestAnimationFrame(this.resetBind);
    };
    VanillaTilt.prototype.reset = function reset() {
        this.onMouseEnter();
        if (this.fullPageListening) this.event = {
            clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
            clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
        };
        else this.event = {
            clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
            clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
        };
        var backupScale = this.settings.scale;
        this.settings.scale = 1;
        this.update();
        this.settings.scale = backupScale;
        this.resetGlare();
    };
    VanillaTilt.prototype.resetGlare = function resetGlare() {
        if (this.glare) {
            this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "0";
        }
    };
    VanillaTilt.prototype.getValues = function getValues() {
        var x = void 0, y = void 0;
        if (this.fullPageListening) {
            x = this.event.clientX / this.clientWidth;
            y = this.event.clientY / this.clientHeight;
        } else {
            x = (this.event.clientX - this.left) / this.width;
            y = (this.event.clientY - this.top) / this.height;
        }
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
        var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
        var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);
        return {
            tiltX: tiltX,
            tiltY: tiltY,
            percentageX: x * 100,
            percentageY: y * 100,
            angle: angle
        };
    };
    VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
        var rect = this.element.getBoundingClientRect();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.left = rect.left;
        this.top = rect.top;
    };
    VanillaTilt.prototype.update = function update() {
        var values = this.getValues();
        this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";
        if (this.glare) {
            this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
        }
        this.element.dispatchEvent(new CustomEvent("tiltChange", {
            "detail": values
        }));
        this.updateCall = null;
    };
    /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */ VanillaTilt.prototype.prepareGlare = function prepareGlare() {
        // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
        if (!this.glarePrerender) {
            // Create glare element
            var jsTiltGlare = document.createElement("div");
            jsTiltGlare.classList.add("js-tilt-glare");
            var jsTiltGlareInner = document.createElement("div");
            jsTiltGlareInner.classList.add("js-tilt-glare-inner");
            jsTiltGlare.appendChild(jsTiltGlareInner);
            this.element.appendChild(jsTiltGlare);
        }
        this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
        this.glareElement = this.element.querySelector(".js-tilt-glare-inner");
        if (this.glarePrerender) return;
        Object.assign(this.glareElementWrapper.style, {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "overflow": "hidden",
            "pointer-events": "none",
            "border-radius": "inherit"
        });
        Object.assign(this.glareElement.style, {
            "position": "absolute",
            "top": "50%",
            "left": "50%",
            "pointer-events": "none",
            "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            "transform": "rotate(180deg) translate(-50%, -50%)",
            "transform-origin": "0% 0%",
            "opacity": "0"
        });
        this.updateGlareSize();
    };
    VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
        if (this.glare) {
            var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;
            Object.assign(this.glareElement.style, {
                "width": glareSize + "px",
                "height": glareSize + "px"
            });
        }
    };
    VanillaTilt.prototype.updateClientSize = function updateClientSize() {
        this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };
    VanillaTilt.prototype.onWindowResize = function onWindowResize() {
        this.updateGlareSize();
        this.updateClientSize();
    };
    VanillaTilt.prototype.setTransition = function setTransition() {
        var _this = this;
        clearTimeout(this.transitionTimeout);
        this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
        if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;
        this.transitionTimeout = setTimeout(function() {
            _this.element.style.transition = "";
            if (_this.glare) _this.glareElement.style.transition = "";
        }, this.settings.speed);
    };
    /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be enabled. Can be "x" or "y"
   * @param {boolean} settings.glare - if it should have a "glare" effect
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {boolean} settings.reset-to-start - true = On reset event (mouse leave) will return to initial start angle (if startX or startY is set)
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */ VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
        var defaultSettings = {
            reverse: false,
            max: 15,
            startX: 0,
            startY: 0,
            perspective: 1000,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            scale: 1,
            speed: 300,
            transition: true,
            axis: null,
            glare: false,
            "max-glare": 1,
            "glare-prerender": false,
            "full-page-listening": false,
            "mouse-event-element": null,
            reset: true,
            "reset-to-start": true,
            gyroscope: true,
            gyroscopeMinAngleX: -45,
            gyroscopeMaxAngleX: 45,
            gyroscopeMinAngleY: -45,
            gyroscopeMaxAngleY: 45,
            gyroscopeSamples: 10
        };
        var newSettings = {};
        for(var property in defaultSettings){
            if (property in settings) newSettings[property] = settings[property];
            else if (this.element.hasAttribute("data-tilt-" + property)) {
                var attribute = this.element.getAttribute("data-tilt-" + property);
                try {
                    newSettings[property] = JSON.parse(attribute);
                } catch (e) {
                    newSettings[property] = attribute;
                }
            } else newSettings[property] = defaultSettings[property];
        }
        return newSettings;
    };
    VanillaTilt.init = function init(elements, settings) {
        if (elements instanceof Node) elements = [
            elements
        ];
        if (elements instanceof NodeList) elements = [].slice.call(elements);
        if (!(elements instanceof Array)) return;
        elements.forEach(function(element) {
            if (!("vanillaTilt" in element)) element.vanillaTilt = new VanillaTilt(element, settings);
        });
    };
    return VanillaTilt;
}();
if (typeof document !== "undefined") {
    /* expose the class to window */ window.VanillaTilt = $b5f6d4efc654cf78$var$VanillaTilt;
    /**
   * Auto load
   */ $b5f6d4efc654cf78$var$VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}
$b5f6d4efc654cf78$exports = $b5f6d4efc654cf78$var$VanillaTilt;


function $b8855ed206bb3c2e$export$2e2bcd8739ae039() {
    const elements = document.querySelectorAll(".js-tilt");
    (0, (/*@__PURE__*/$parcel$interopDefault($b5f6d4efc654cf78$exports))).init(elements);
}


const $d859da13df4a30ff$export$9c21a3269931e1e6 = {
    easing: "cubic-bezier(0.5, 0, 0, 1)",
    distance: "30px",
    duration: 1000,
    desktop: true,
    mobile: true
};
const $d859da13df4a30ff$export$adcf75ad64a03007 = [
    {
        element: ".section-title",
        animation: {
            delay: 300,
            distance: "0px",
            origin: "bottom"
        }
    },
    {
        element: ".hero-title",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".hero-cta",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".about-wrapper__image",
        animation: {
            delay: 600,
            origin: "bottom"
        }
    },
    {
        element: ".about-wrapper__info",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".project-wrapper__text",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".tag-cluster",
        animation: {
            delay: 800,
            origin: window.innerWidth > 768 ? "bottom" : "bottom"
        }
    },
    {
        element: ".project-wrapper__image",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    },
    {
        element: ".contact-wrapper",
        animation: {
            delay: 800,
            origin: "bottom"
        }
    }
];


// Project filtering, searching, sorting, and pagination
const $3489824408ff022f$var$PROJECTS_PER_PAGE = 5;
let $3489824408ff022f$var$currentPage = 1;
let $3489824408ff022f$var$filteredProjects = [];
let $3489824408ff022f$var$allProjects = [];
// Initialize on DOM load
document.addEventListener('DOMContentLoaded', ()=>{
    $3489824408ff022f$export$4e12daff7c0b8ec6();
    $3489824408ff022f$var$setupEventListeners();
    // Apply initial sort (newest first by default)
    const sortSelect = document.getElementById('sortProjects');
    if (sortSelect) $3489824408ff022f$var$handleSort(sortSelect.value);
    else $3489824408ff022f$export$b42c15f498e1621b();
});
function $3489824408ff022f$export$4e12daff7c0b8ec6() {
    const projectElements = document.querySelectorAll('.project-item');
    $3489824408ff022f$var$allProjects = Array.from(projectElements);
    $3489824408ff022f$var$filteredProjects = [
        ...$3489824408ff022f$var$allProjects
    ];
    // Update project count in title
    const projectCountEl = document.getElementById('projectCount');
    if (projectCountEl) projectCountEl.textContent = $3489824408ff022f$var$allProjects.length;
}
function $3489824408ff022f$var$setupEventListeners() {
    // Search
    const searchInput = document.getElementById('projectSearch');
    if (searchInput) searchInput.addEventListener('input', (e)=>{
        $3489824408ff022f$var$handleSearch(e.target.value);
    });
    // Sort
    const sortSelect = document.getElementById('sortProjects');
    if (sortSelect) sortSelect.addEventListener('change', (e)=>{
        $3489824408ff022f$var$handleSort(e.target.value);
    });
    // Filter toggle
    const filterToggle = document.getElementById('filterToggle');
    const filterPanel = document.getElementById('techFilterPanel');
    if (filterToggle && filterPanel) {
        filterToggle.addEventListener('click', (e)=>{
            e.stopPropagation();
            filterPanel.classList.toggle('hidden');
        });
        // Close filter panel when clicking outside
        document.addEventListener('click', (e)=>{
            if (!filterPanel.classList.contains('hidden')) {
                const techFilter = document.querySelector('.tech-filter');
                if (techFilter && !techFilter.contains(e.target)) filterPanel.classList.add('hidden');
            }
        });
        // Prevent clicks inside the panel from closing it
        filterPanel.addEventListener('click', (e)=>{
            e.stopPropagation();
        });
    }
    // Tech filter checkboxes
    const techCheckboxes = document.querySelectorAll('.tech-checkbox');
    techCheckboxes.forEach((checkbox)=>{
        checkbox.addEventListener('change', $3489824408ff022f$var$handleFilter);
    });
    // Clear filters
    const clearBtn = document.getElementById('clearFilters');
    if (clearBtn) clearBtn.addEventListener('click', ()=>{
        techCheckboxes.forEach((cb)=>cb.checked = false);
        $3489824408ff022f$var$handleFilter();
    });
}
function $3489824408ff022f$var$handleSearch(query) {
    $3489824408ff022f$var$applyAllFilters();
}
function $3489824408ff022f$var$handleFilter() {
    $3489824408ff022f$var$applyAllFilters();
}
function $3489824408ff022f$var$applyAllFilters() {
    console.log("\u26A0\uFE0F applyAllFilters() called");
    const searchInput = document.getElementById('projectSearch');
    const searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';
    const activeFilters = $3489824408ff022f$var$getActiveFilters();
    // Start with all projects
    let results = [
        ...$3489824408ff022f$var$allProjects
    ];
    // Apply search filter
    if (searchTerm) results = results.filter((project)=>{
        const title = project.querySelector('.project-wrapper__text-title')?.textContent.toLowerCase() || '';
        const description = project.querySelector('.mb-4')?.textContent.toLowerCase() || '';
        const tags = project.dataset.tags || '';
        return title.includes(searchTerm) || description.includes(searchTerm) || tags.includes(searchTerm);
    });
    // Apply tech filters (AND logic - project must have ALL selected tags)
    if (activeFilters.length > 0) results = results.filter((project)=>{
        const tags = project.dataset.tags?.split(',') || [];
        return activeFilters.every((filter)=>tags.includes(filter));
    });
    $3489824408ff022f$var$filteredProjects = results;
    $3489824408ff022f$var$currentPage = 1;
    // Re-apply the current sort after filtering
    const sortSelect = document.getElementById('sortProjects');
    if (sortSelect && sortSelect.value) {
        console.log(`Re-applying sort: ${sortSelect.value}`);
        $3489824408ff022f$var$applySortOnly(sortSelect.value);
    }
    $3489824408ff022f$export$b42c15f498e1621b();
}
function $3489824408ff022f$var$getActiveFilters() {
    const checkboxes = document.querySelectorAll('.tech-checkbox:checked');
    return Array.from(checkboxes).map((cb)=>cb.value);
}
function $3489824408ff022f$var$applySortOnly(sortType) {
    $3489824408ff022f$var$filteredProjects.sort((a, b)=>{
        if (sortType === 'newest' || sortType === 'oldest') {
            const dateA = new Date(a.dataset.timestamp);
            const dateB = new Date(b.dataset.timestamp);
            return sortType === 'newest' ? dateB - dateA : dateA - dateB;
        } else if (sortType === 'scale-desc' || sortType === 'scale-asc') {
            // Use hours for precise scale sorting
            const hoursA = parseInt(a.dataset.hours) || 0;
            const hoursB = parseInt(b.dataset.hours) || 0;
            return sortType === 'scale-desc' ? hoursB - hoursA : hoursA - hoursB;
        }
        return 0;
    });
}
function $3489824408ff022f$var$handleSort(sortType) {
    console.log(`\u{1F504} handleSort(${sortType}) called`);
    $3489824408ff022f$var$applySortOnly(sortType);
    // Always go back to page 1 when sorting changes
    $3489824408ff022f$var$currentPage = 1;
    // Debug: Log final sorted order
    if (sortType === 'scale-desc') {
        console.log('\n=== FINAL SORTED ORDER ===');
        $3489824408ff022f$var$filteredProjects.forEach((project, index)=>{
            const title = project.querySelector('.project-wrapper__text-title')?.textContent.trim().substring(0, 40);
            const hours = project.dataset.hours;
            console.log(`${index + 1}. ${title} - ${hours}h`);
        });
        console.log('========================\n');
    }
    $3489824408ff022f$export$b42c15f498e1621b();
}
function $3489824408ff022f$export$b42c15f498e1621b() {
    const container = document.getElementById('projectsContainer');
    if (!container) return;
    // Hide all projects first
    $3489824408ff022f$var$allProjects.forEach((project)=>{
        project.style.display = 'none';
    });
    // Calculate pagination
    const startIndex = ($3489824408ff022f$var$currentPage - 1) * $3489824408ff022f$var$PROJECTS_PER_PAGE;
    const endIndex = startIndex + $3489824408ff022f$var$PROJECTS_PER_PAGE;
    const projectsToShow = $3489824408ff022f$var$filteredProjects.slice(startIndex, endIndex);
    // Debug: Log what we're displaying
    console.log(`\n=== DISPLAYING PAGE ${$3489824408ff022f$var$currentPage} ===`);
    console.log(`Showing projects ${startIndex} to ${endIndex - 1}`);
    projectsToShow.forEach((project, index)=>{
        const title = project.querySelector('.project-wrapper__text-title')?.textContent.trim().substring(0, 40);
        console.log(`  ${startIndex + index + 1}. ${title}`);
    });
    console.log('========================\n');
    // REORDER DOM: Append projects to container in the correct order
    projectsToShow.forEach((project)=>{
        container.appendChild(project);
        project.style.display = 'flex';
        // Remove load-hidden class to prevent animation delays
        const hiddenElements = project.querySelectorAll('.load-hidden');
        hiddenElements.forEach((el)=>{
            el.classList.remove('load-hidden');
            el.style.visibility = 'visible';
            el.style.opacity = '1';
        });
    });
    // Update pagination
    $3489824408ff022f$var$updatePagination();
}
function $3489824408ff022f$var$updatePagination() {
    const totalPages = Math.ceil($3489824408ff022f$var$filteredProjects.length / $3489824408ff022f$var$PROJECTS_PER_PAGE);
    const paginationContainer = document.getElementById('pagination');
    const pageInfo = document.getElementById('pageInfo');
    if (!paginationContainer) return;
    // Update page info
    if (pageInfo) {
        const startItem = ($3489824408ff022f$var$currentPage - 1) * $3489824408ff022f$var$PROJECTS_PER_PAGE + 1;
        const endItem = Math.min($3489824408ff022f$var$currentPage * $3489824408ff022f$var$PROJECTS_PER_PAGE, $3489824408ff022f$var$filteredProjects.length);
        pageInfo.textContent = `Showing ${startItem}-${endItem} of ${$3489824408ff022f$var$filteredProjects.length} projects`;
    }
    // Clear pagination
    paginationContainer.innerHTML = '';
    if (totalPages <= 1) return;
    // Previous button
    const prevBtn = $3489824408ff022f$var$createPageButton("\u2039", $3489824408ff022f$var$currentPage > 1, ()=>{
        if ($3489824408ff022f$var$currentPage > 1) {
            $3489824408ff022f$var$currentPage--;
            $3489824408ff022f$export$b42c15f498e1621b();
            $3489824408ff022f$var$scrollToProjects();
        }
    });
    paginationContainer.appendChild(prevBtn);
    // Page numbers
    const maxVisible = 5;
    let startPage = Math.max(1, $3489824408ff022f$var$currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    if (endPage - startPage < maxVisible - 1) startPage = Math.max(1, endPage - maxVisible + 1);
    // First page
    if (startPage > 1) {
        paginationContainer.appendChild($3489824408ff022f$var$createPageButton('1', true, ()=>$3489824408ff022f$var$goToPage(1)));
        if (startPage > 2) {
            const dots = document.createElement('span');
            dots.className = 'pagination-dots';
            dots.textContent = '...';
            paginationContainer.appendChild(dots);
        }
    }
    // Page numbers
    for(let i = startPage; i <= endPage; i++){
        const btn = $3489824408ff022f$var$createPageButton(i.toString(), true, ()=>$3489824408ff022f$var$goToPage(i));
        if (i === $3489824408ff022f$var$currentPage) btn.classList.add('active');
        paginationContainer.appendChild(btn);
    }
    // Last page
    if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
            const dots = document.createElement('span');
            dots.className = 'pagination-dots';
            dots.textContent = '...';
            paginationContainer.appendChild(dots);
        }
        paginationContainer.appendChild($3489824408ff022f$var$createPageButton(totalPages.toString(), true, ()=>$3489824408ff022f$var$goToPage(totalPages)));
    }
    // Next button
    const nextBtn = $3489824408ff022f$var$createPageButton("\u203A", $3489824408ff022f$var$currentPage < totalPages, ()=>{
        if ($3489824408ff022f$var$currentPage < totalPages) {
            $3489824408ff022f$var$currentPage++;
            $3489824408ff022f$export$b42c15f498e1621b();
            $3489824408ff022f$var$scrollToProjects();
        }
    });
    paginationContainer.appendChild(nextBtn);
}
function $3489824408ff022f$var$createPageButton(text, enabled, onClick) {
    const button = document.createElement('button');
    button.className = 'page-btn';
    button.textContent = text;
    button.disabled = !enabled;
    if (enabled) button.addEventListener('click', onClick);
    return button;
}
function $3489824408ff022f$var$goToPage(page) {
    $3489824408ff022f$var$currentPage = page;
    $3489824408ff022f$export$b42c15f498e1621b();
    $3489824408ff022f$var$scrollToProjects();
}
function $3489824408ff022f$var$scrollToProjects() {
    const projectsSection = document.getElementById('projects');
    if (projectsSection) projectsSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}


(0, $6f019d1f45ba2738$export$2e2bcd8739ae039)((0, $d859da13df4a30ff$export$adcf75ad64a03007), (0, $d859da13df4a30ff$export$9c21a3269931e1e6));
(0, $b8855ed206bb3c2e$export$2e2bcd8739ae039)();


//# sourceMappingURL=repo.0c578d7b.js.map
